import { SendFormData, wclValidateForm, wclValidateField, hideAlertMessageOnFocus } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

   if (document.querySelector('.wcl-modal-login-form')) {
      const form = document.querySelector('.wcl-modal-login-form');
      const modalFormWrapper = form.closest('.wcl-modal-inner');

      // Get variables
      const wpnonce = form.querySelector('#wcl_log_in_wpnonce');
      const submitBtn = form.querySelector('#wcl-log-in-button');

      // Get UI element
      const messageBlock = form.querySelector('.wcl-message-alert');
      const message = form.querySelector('.wcl-message');

      submitBtn.addEventListener('click', e => {
         e.preventDefault();

         messageBlock.classList.remove('show', 'error', 'success');

         // Validation
         if (!wclValidateForm(form)) {
            return;
         }

         modalFormWrapper.classList.add('loading');

         let formData = new FormData(form);

         // Add wpnonce to data array
         formData.append('wpnonce', wpnonce.value);

         SendFormData('log_in', formData).then(function (res) {
            modalFormWrapper.classList.remove('loading');

            let response = JSON.parse(res);

            if (response.success == '1') {
               window.location.reload();
            } else {
               throw response.message;
            }

         }).catch(function (err) {
            // Error
            modalFormWrapper.classList.remove('loading');

            messageBlock.classList.add('show', 'error');
            message.innerHTML = err;

            hideAlertMessageOnFocus(form, messageBlock);
         });
      });

   }
});